import { render } from "./PaymentTermsComponent.vue?vue&type=template&id=42aa37d7&scoped=true"
import script from "./PaymentTermsComponent.vue?vue&type=script&lang=js"
export * from "./PaymentTermsComponent.vue?vue&type=script&lang=js"

import "./PaymentTermsComponent.vue?vue&type=style&index=0&id=42aa37d7&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42aa37d7"]])

export default __exports__